import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import { AddressValidationStatus } from "@omni/types/api/customer/cloud/shared/enums/addressValidationStatus.enum";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { AddressValidationProvider } from "@/components/Address/context/AddressValidation/addressValidation.context";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as AddressModule from "@/redux/modules/api/data/address/address.module";
import * as AddressBookModule from "@/redux/modules/api/data/addressbook/addressbook.module";
import * as AddressBookSelectors from "@/redux/modules/api/data/addressbook/addressbook.selectors";
import { getCreateAddressObject } from "@/utils/address/address";

import AddressBook from "./profileAddressBook.component";

const ProfileAddressBook = () => {
    const isLoadingAddresses = useSelector(AddressBookSelectors.isLoading);
    const addressBookError = useSelector(AddressBookSelectors.getErrors);
    const addresses = useSelector(AddressBookSelectors.getAddresses);

    const dispatch = useThunkDispatch();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        dispatch(AddressBookModule.load());
    }, []);

    const onUpdateDefaultBilling = async (address: CloudCustomerAddress) => {
        await dispatch(AddressModule.updateDefaultBilling(address));
    };

    const onUpdateDefaultDelivery = async (address: CloudCustomerAddress) => {
        await dispatch(AddressModule.updateDefaultDelivery(address));
    };

    const onCreateAddress = async (
        addressing: string | null | undefined,
        firstName: string,
        lastName: string,
        country: string,
        city: string,
        street: string,
        box: string | null | undefined,
        number: string,
        zipCode: string,
        validationStatus: AddressValidationStatus
    ) => {
        await dispatch(
            AddressModule.create([
                getCreateAddressObject(
                    addressing,
                    firstName,
                    lastName,
                    country,
                    city,
                    street,
                    box,
                    number,
                    zipCode,
                    validationStatus
                )
            ])
        );
    };

    const onUpdateAddress = async (address: CloudCustomerAddress) => {
        await dispatch(
            AddressModule.update(
                address.id,
                address.addressing,
                address.firstName,
                address.lastName,
                address.country,
                address.city,
                address.street,
                address.box,
                address.number,
                address.zipCode,
                address.validationStatus,
                address.defaultDeliveryAddress,
                address.defaultPaymentAddress
            )
        );
    };

    return (
        <AddressValidationProvider>
            <AddressBook
                error={addressBookError}
                loading={isLoadingAddresses}
                addresses={addresses || []}
                updateDefaultBilling={onUpdateDefaultBilling}
                updateDefaultDelivery={onUpdateDefaultDelivery}
                createAddress={onCreateAddress}
                updateAddress={onUpdateAddress}
            />
        </AddressValidationProvider>
    );
};

export { ProfileAddressBook };
